import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  Empty,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
  SocialIcon,
  FooterAboutContainer,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: { t: TFunction }) => {
  // const handleChange = (language: string) => {
  //   i18n.changeLanguage(language);
  // };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
        style={{ padding: '0 1rem' }}
      >
        <SocialIcon src={src} />
      </a>
    );
  };

  return (
    <>
      <FooterSection>
        <Container>
          {/* <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Language>{t("Contact")}</Language>
              <Large to="/">{t("Tell us everything")}</Large>
              <Para>
                {t(`Do you have any question? Feel free to reach out.`)}
              </Para>
              <a href="mailto:hello@pixelkinggaming.com">
                <Chat>{t(`Let's Chat`)}</Chat>
              </a>
            </Col>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Title>{t("Policy")}</Title>
              <Large to="/">{t("Application Security")}</Large>
              <Large to="/">{t("Software Principles")}</Large>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <Empty />
              <Large to="/">{t("Support Center")}</Large>
              <Large to="/">{t("Customer Support")}</Large>
            </Col>
          </Row>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Empty />
              <Language>{t("Address")}</Language>
              <Para>South East</Para>
              <Para>England</Para>
              <Para>United Kingdom</Para>
            </Col>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Title>{t("Company")}</Title>
              <Large to="/">{t("About")}</Large>
              <Large to="/">{t("Blog")}</Large>
              <Large to="/">{t("Press")}</Large>
              <Large to="/">{t("Careers & Culture")}</Large>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <Label htmlFor="select-lang">{t("Language")}</Label>
              <LanguageSwitchContainer>
                <LanguageSwitch onClick={() => handleChange("en")}>
                  <SvgIcon
                    src="united-states.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
                <LanguageSwitch onClick={() => handleChange("es")}>
                  <SvgIcon
                    src="spain.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
              </LanguageSwitchContainer>
            </Col>
          </Row> */}

          <FooterAboutContainer>
            <b>Privacy Policy:</b> We collect information you provide directly to us, such as your name, email, and any other details you submit through forms on our website.
            We will not share your personal data with third parties without your consent, except where required by law.
            We implement security measures to protect your data. However, no method of data transmission over the internet is completely secure, and we cannot guarantee absolute security.
            We do not use cookies or similar tracking technologies on our website. By using our website, you consent to this privacy policy.
            <br /><br />Copyright {new Date().getFullYear()} &#169; Pixel King Limited. All rights reserved. Company number 15937667. Registered in England.<br />
            Some icons by <a target="_blank" rel="noreferrer" href="https://www.icons8.com">icons8</a>.
          </FooterAboutContainer>
        </Container>

      </FooterSection>
      <Extra>
        {/* <Container border={true}> */}
        <Container>
          <Row
            justify="space-between"
            align="middle"
          >
            <NavLink to="/">
              <LogoContainer>
                {/* <SvgIcon
                  src="pkg-logo.png"
                  aria-label="homepage"
                  width="101px"
                  height="64px"
                /> */}
                <img srcSet="/img/pngs/logo2x.png 2x" src="/img/pngs/logo1x.png" alt="Pixel King Gaming logo" style={{ filter: 'brightness(0) invert(1)', opacity: '0.7' }} />
              </LogoContainer>
            </NavLink>
            <FooterContainer>
              {/* <SocialLink
                href="https://github.com/"
                src="github.svg"
              />
              <SocialLink
                href="https://twitter.com/"
                src="twitter.svg"
              /> */}
              <SocialLink
                href="https://www.linkedin.com/company/pixel-king-gaming"
                src="img/pngs/icons8/icons8-linkedin-60.png"
              />
              <SocialLink
                href="https://www.youtube.com/@PixelKingGaming-g2v"
                src="img/pngs/icons8/icons8-youtube-50.png"
              />
              {/* <a
                href="https://ko-fi.com/Y8Y7H8BNJ"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  height="36"
                  style={{ border: 0, height: 36 }}
                  src="https://storage.ko-fi.com/cdn/kofi3.png?v=3"
                  alt="Buy Me a Coffee"
                />
              </a> */}
            </FooterContainer>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
